import { Link } from "react-router-dom";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";

export default function TreeTrimmingPage() {
  return (
    <>
      <Header />
      <main>
        <section className="relative min-h-[55vh] flex items-center">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/bdce82f34119158ada956e220fd5d9bd.jpg"
              alt="Professional tree trimming Northern Virginia"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a2e]/90 to-[#1a3a2e]/40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-20">
            <div className="max-w-xl">
              <div className="flex items-center gap-2 text-[#e8632a] text-sm font-bold uppercase tracking-widest mb-4">
                <Link to="/services" className="hover:text-white cursor-pointer">Services</Link>
                <i className="ri-arrow-right-s-line"></i>
                Tree Trimming
              </div>
              <h1 className="text-5xl lg:text-6xl font-black text-white mb-4">Tree Trimming & Pruning Services</h1>
              <p className="text-white/80 text-xl mb-8">Improve tree health, shape, and safety with professional pruning from ISA Certified Arborists.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="flex items-center justify-center gap-2 px-8 py-4 bg-[#e8632a] text-white font-black rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap">
                  Get Free Estimate
                </Link>
                <a href="tel:+15407764488" className="flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white font-black rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#1a3a2e] transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-fill"></i>(540) 776-4488
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">Expert Pruning</span>
              <h2 className="text-4xl font-black text-[#1e1e1e] mb-6">Why Tree Trimming Matters</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Regular tree trimming isn't just about looks — it's essential for the long-term health of your trees and the safety of your property. Overgrown branches can damage roofs, power lines, and foundations. Dead limbs are a serious falling hazard.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Our ISA Certified Arborists follow industry best practices for every cut, ensuring trees heal properly and thrive for years to come. We use bucket trucks and hand-climbing for precise, damage-free results.
              </p>
              <div className="grid grid-cols-2 gap-3">
                {["Crown Thinning", "Crown Raising", "Deadwood Removal", "Vista Pruning", "Storm Preparation", "Clearance Trimming", "Shape & Balance", "Health Assessment"].map((f) => (
                  <div key={f} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-scissors-cut-line text-[#e8632a] flex-shrink-0"></i>
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20arborist%20certified%20tree%20climber%20in%20harness%20safety%20gear%20pruning%20high%20branches%20large%20oak%20tree%20residential%20backyard%20rope%20access%20northern%20virginia&width=700&height=500&seq=ttrim002&orientation=landscape"
                alt="ISA certified arborist trimming tree"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        <section className="py-20 bg-[#f8f6f3]">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <h2 className="text-4xl font-black text-[#1e1e1e] text-center mb-12">When to Trim Your Trees</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { icon: "ri-sun-line", title: "Late Winter / Early Spring", desc: "Ideal timing for most trees. Dormant pruning promotes vigorous spring growth and reduces disease risk." },
                { icon: "ri-alarm-warning-line", title: "After Storm Damage", desc: "Broken or hanging branches are emergency hazards. Call us immediately for storm damage response." },
                { icon: "ri-home-4-line", title: "Clearance Issues", desc: "Branches touching your roof, blocking power lines, or blocking light should be trimmed year-round." },
              ].map((t) => (
                <div key={t.title} className="bg-white rounded-2xl p-8 text-center">
                  <i className={`${t.icon} text-4xl text-[#e8632a] mb-4 block`}></i>
                  <h3 className="font-black text-[#1e1e1e] text-lg mb-3">{t.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-[#e8632a] text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-4xl font-black text-white mb-4">Schedule Tree Trimming Today</h2>
            <p className="text-white/80 mb-8">Keep your trees healthy and your property safe. Free estimates, fast service.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="px-8 py-4 bg-white text-[#e8632a] font-black rounded-lg uppercase tracking-wide hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap">Free Estimate</Link>
              <a href="tel:+15407764488" className="px-8 py-4 border-2 border-white text-white font-black rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                <i className="ri-phone-fill"></i>(540) 776-4488
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
